import { Button } from '@finn/design-system/atoms/button';
import { interactionTrackingEvent, TrackingEventName } from '@finn/ua-tracking';
import { VehicleContext } from '@finn/ua-vehicle';
import { cn, useIntl } from '@finn/ui-utils';
import { useCallback, useContext } from 'react';

export enum ContinueButtonLocation {
  STICKY = 'sticky',
  MAIN = 'main',
}

// scroll position of top-left corner in range [0...1]
const getCTAScrollPosition = () =>
  Math.round(
    (window.scrollY /
      (document.documentElement.scrollHeight - window.innerHeight)) *
      10000
  ) / 10000;

type Props = {
  location?: ContinueButtonLocation;
  buttonClassName?: string;
  onClick: () => void;
  isLoading: boolean;
  testId?: string;
};

export const ContinueButton = ({
  location,
  buttonClassName,
  isLoading,
  onClick,
  testId,
}: Props) => {
  const i18n = useIntl();
  const { vehicle } = useContext(VehicleContext);

  const handleClick = useCallback(() => {
    const categoryIndex = vehicle?.id.indexOf('category-');
    const category =
      categoryIndex !== -1 ? vehicle?.id.substring(categoryIndex + 9) : null;

    if (location) {
      interactionTrackingEvent(TrackingEventName.CTA_CLICKED, {
        location,
        make: vehicle?.brand?.id,
        model: vehicle?.model,
        product_id: vehicle?.id,
        category,
        scrollPosition: getCTAScrollPosition(),
      });
    }

    onClick();
  }, [location, onClick]);

  const title = i18n.formatMessage(`pdp.configureBeforeBooking2`);

  return (
    <Button
      className={cn('w-full', buttonClassName)}
      loading={isLoading}
      testId={testId || 'submit'}
      disabled={isLoading}
      onClick={handleClick}
    >
      {title}
    </Button>
  );
};
